/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull partners_platform'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/irev/IREV/implementation/partners_platform)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'irev';

export const ApiKey: Record<Environment, string> = {
  irev: 'a2cd6faf44c33a05c95e1b90aec3d3f1',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'partners_platform',
    versionId: 'a28a39a1-6fd5-4321-b091-a13d9440e69f',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions } };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface ExecuteActionProperties {
  name: string;
}

export interface GenerateCohortReportProperties {
  'company name': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  conditions: string[];
  'goal type': string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  groups: string[];
  month: string;
}

export interface GenerateDataExporterProperties {
  name: string;
}

export interface GenerateDrilldownProperties {
  name: string;
}

export interface GetTableProperties {
  name: string;
}

export interface GetWidgetProperties {
  name: string;
}

export class ExecuteAction implements BaseEvent {
  event_type = 'Execute Action';

  constructor(public event_properties: ExecuteActionProperties) {
    this.event_properties = event_properties;
  }
}

export class GenerateCohortReport implements BaseEvent {
  event_type = 'Generate Cohort Report';

  constructor(public event_properties: GenerateCohortReportProperties) {
    this.event_properties = event_properties;
  }
}

export class GenerateDataExporter implements BaseEvent {
  event_type = 'Generate Data Exporter';

  constructor(public event_properties: GenerateDataExporterProperties) {
    this.event_properties = event_properties;
  }
}

export class GenerateDrilldown implements BaseEvent {
  event_type = 'Generate Drilldown';

  constructor(public event_properties: GenerateDrilldownProperties) {
    this.event_properties = event_properties;
  }
}

export class GetTable implements BaseEvent {
  event_type = 'Get Table';

  constructor(public event_properties: GetTableProperties) {
    this.event_properties = event_properties;
  }
}

export class GetWidget implements BaseEvent {
  event_type = 'Get Widget';

  constructor(public event_properties: GetWidgetProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration, defaultTracking: true });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param email The user's Email.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    email: string,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify().set('email', email);
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Execute Action
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Execute%20Action)
   *
   * This event tracks when a user performs a specific action within the platform.
   *
   * Owner: Artem Larionov
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  executeAction(
    properties: ExecuteActionProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExecuteAction(properties), options);
  }

  /**
   * Generate Cohort Report
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Generate%20Cohort%20Report)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. company name)
   * @param options Amplitude event options.
   */
  generateCohortReport(
    properties: GenerateCohortReportProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateCohortReport(properties), options);
  }

  /**
   * Generate Data Exporter
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Generate%20Data%20Exporter)
   *
   * When user sets up settings for Data Exporter and clicks View Report
   *
   * Owner: Artem Larionov
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  generateDataExporter(
    properties: GenerateDataExporterProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateDataExporter(properties), options);
  }

  /**
   * Generate Drilldown
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Generate%20Drilldown)
   *
   * When user sets up settings for Drilldown and clicks Generate Drilldown
   *
   * Owner: Artem Larionov
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  generateDrilldown(
    properties: GenerateDrilldownProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateDrilldown(properties), options);
  }

  /**
   * Get Table
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Get%20Table)
   *
   * When a user loads a table
   *
   * Owner: Artem Larionov
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  getTable(
    properties: GetTableProperties,
    options?: EventOptions,
  ) {
    return this.track(new GetTable(properties), options);
  }

  /**
   * Get Widget
   *
   * [View in Tracking Plan](https://data.amplitude.com/irev/IREV/events/main/latest/Get%20Widget)
   *
   * This event tracks when users interact with the widget on the platform.
   *
   * Owner: Artem Larionov
   *
   * @param properties The event's properties (e.g. name)
   * @param options Amplitude event options.
   */
  getWidget(
    properties: GetWidgetProperties,
    options?: EventOptions,
  ) {
    return this.track(new GetWidget(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
